








































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { Country, Region } from '@/models/index'
import { IValidationError } from 'spraypaint/lib-esm/validation-errors'
import request from '@/utils/request'

@Component({
  name: 'CountryEdit'
})
export default class extends Vue {
  private country: Country = new Country()
  private loading = false
  private allRegions: Region[] = []
  private selectedRegionIds: string[] = []
  private rules = {
    name: [{ required: true, message: 'Le nom est obligatoire', trigger: 'blur' }],
    code: [{ required: true, message: 'Le code est obligatoire', trigger: 'blur' }]
  }

  created() {
    this.init()
  }

  @Watch('$route')
  private onRouteChange() {
    if (this.$route.name !== 'CountryCreate' && this.$route.name !== 'CountryEdit') return
    this.init()
  }

  get isCreate() {
    return this.$route.name === 'CountryCreate'
  }

  private init() {
    this.country = new Country()
    this.selectedRegionIds = []
    this.loadRegions()
    if (!this.isCreate) {
      this.getCountry()
    }
  }

  private async loadRegions() {
    const { data } = await Region
      .order({ name: 'asc' })
      .per(999)
      .all()
    this.allRegions = data
  }

  private async getCountry() {
    this.loading = true
    const { data } = await Country
      .includes(['regions'])
      .find(this.$route.params.id)

    this.country = data
    this.selectedRegionIds = (data.regions || []).map((r: Region) => r.id)
    this.loading = false
  }

  private async createOrUpdate() {
    (this.$refs.dataForm as Form).validate(async(valid: any) => {
      if (valid) {
        if (this.isCreate) {
          await this.country.save()

          if (Object.keys(this.country.errors).length > 0) {
            this.printErrors(this.country.errors)
          } else {
            this.$notify({
              title: 'Pays créé',
              message: 'Le pays a été créé avec succès',
              type: 'success',
              duration: 2000
            })
            this.$router.replace({ name: 'CountryEdit', params: { id: this.country.id as string } }).catch(err => err)
          }
        } else {
          try {
            await request.patch(`/admin/countries/${this.country.id}`, {
              data: {
                type: 'countries',
                id: this.country.id,
                attributes: {
                  name: this.country.name,
                  code: this.country.code
                },
                relationships: {
                  regions: {
                    data: this.selectedRegionIds.map(id => ({ type: 'regions', id }))
                  }
                }
              }
            }, {
              headers: { 'Content-Type': 'application/vnd.api+json' }
            })

            this.$notify({
              title: 'Pays mis à jour',
              message: 'Le pays a été mis à jour avec succès',
              type: 'success',
              duration: 2000
            })
            await this.getCountry()
          } catch (e: any) {
            if (e.response?.data?.errors) {
              for (const err of e.response.data.errors) {
                this.$notify({ title: err.title, message: err.detail, type: 'error', duration: 5000 })
              }
            }
          }
        }
      }
    })
  }

  private printErrors(errors: any) {
    const e: (IValidationError<Country> | undefined)[] = Object.values(errors)
    for (const error of e) {
      if (error) {
        this.$notify({
          title: error.title,
          message: error.fullMessage,
          type: 'error',
          duration: 5000
        })
      }
    }
  }
}
